var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckboxChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6C0 2.68629 2.68629 0 6 0H19.5C22.8137 0 25.5 2.68629 25.5 6V19C25.5 22.3137 22.8137 25 19.5 25H6C2.68629 25 0 22.3137 0 19V6Z",
    fill: "#F5F5F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 12.5L11.5 15L16.5 10",
    stroke: "#2196F3",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 1H19.5V-1H6V1ZM24.5 6V19H26.5V6H24.5ZM19.5 24H6V26H19.5V24ZM1 19V6H-1V19H1ZM6 24C3.23858 24 1 21.7614 1 19H-1C-1 22.866 2.13401 26 6 26V24ZM24.5 19C24.5 21.7614 22.2614 24 19.5 24V26C23.366 26 26.5 22.866 26.5 19H24.5ZM19.5 1C22.2614 1 24.5 3.23858 24.5 6H26.5C26.5 2.13401 23.366 -1 19.5 -1V1ZM6 -1C2.13401 -1 -1 2.13401 -1 6H1C1 3.23858 3.23858 1 6 1V-1Z",
    fill: "#EDE7F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxChecked);
export default __webpack_public_path__ + "static/media/checkbox-checked.841a142b248c236ed3b0aeb125a28132.svg";
export { ForwardRef as ReactComponent };